<template>
  <div class="flex flex-col gap-2 m-auto w-full p-2">
    <!-- TODO -->
    <tbs-error-header 
      :error-list="this.errors"
    />
    <!-- TODO -->
    <tbs-data-table
      :is-edit-mode="isEditMode"
      :loading-plan-list="this.loadingPlanList"
      :tbs-list="this.tbsList"
      :type="this.selectedType"
      :set-error-list="this.setErrorList"
      :set-payload-storage="this.setPayloadStorage"
      :set-payload-blending="this.setPayloadBlending"
      :tbs-header-id="this.tbsHeaderId"
    />
    <!-- TODO -->
    <div v-show="isEditMode">
      <div
        class="grid grid-cols-2 gap-5"
      >
        <vs-button
          :disabled="isLoading"
          type="border"
          :class="`button font-semibold  ${isLoading && 'animate-bounce'} p-0`"
          @click="closeEditMode()"
        >
          Discard Changes
        </vs-button>
        <vs-button
          :disabled="isLoading || this.errors.length > 0"
          :class="`button font-semibold bg-primary-accent ${isLoading && 'animate-bounce'} p-0`"
          @click="onSaveChanges()"
        >
          Save Changes
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'

import TbsDataTable from './TbsCalculatorDataTable.vue'
import TbsErrorHeader from './TbsErrorHeader.vue'
export default {
  components: { TbsErrorHeader, TbsDataTable },
  data()  {
    return {
      errors: [],
      loadingPlans: [],
      isLoading: false,
      types: ['BLENDING','STORAGE','MIXED'],
      selectedType: 'BLENDING',
      tbsList: [],
      isEditMode: false,
      payloadMixed: [],
      payloadStorage: [],
      payloadBlending: []
    }     
  },
  watch: {
    isEditModeProp: {
      immediate: true,
      handler(val) {
        this.isEditMode = val
      }
    },
    tbsListGetter: {
      immediate: true,
      deep: true,
      handler(val) {
        if(Array.isArray(val)) {
          this.tbsList = [...val]
        }
      }
    },
    payloadStorage: {
      immediate: true,
      deep: true,
      handler(val) {
        this.payloadMixed = _.concat(val, this.payloadBlending)
      }
    },
    payloadBlending: {
      immediate: true,
      deep: true,
      handler(val) {
        this.payloadMixed = _.concat(val, this.payloadStorage)
      }
    },
    loadingPlanList: {
      immediate: true,
      handler(val) {
        const isBlending = val.some(t => t.loading_facility?.type !== 'STORAGE')
        const isStorage = val.some(t => t.loading_facility?.type === 'STORAGE')
        if(isBlending && isStorage) { this.selectedType = 'MIXED' }
        else if(isBlending) { this.selectedType = 'BLENDING' }
        else if(isStorage) { this.selectedType = 'STORAGE' }
      }
    }
  },
  mounted() {
    this.fetchTbsList()
  },
  computed: {
    ...mapGetters({
      tbsListGetter: 'TentativeBargeSchedule/tentativeBargeScheduleDetails'
    })
  },
  methods: {
    async fetchTbsList() {
      try {
        this.isLoading = true;
        await this.$store.dispatch('TentativeBargeSchedule/fetchTentativeBargeScheduleDetails', this.tbsId)
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        this.showFailedNotification(this, 'Failed to fetch TBS List, please try again')
      }
    },
    closeEditMode() {
      this.setErrorList([])
      this.fetchTbsList()
      this.onCancelEdit()
    },
    setErrorList(errorList) {
      this.errors = errorList
    },
    setPayloadStorage(tbsData) {
      this.payloadStorage = tbsData
    },
    setPayloadBlending(tbsData) {
      this.payloadBlending = tbsData
    },
    async onSaveChanges() {
      this.isLoading = true
      try {
        await this.$store.dispatch('TentativeBargeSchedule/storeTentativeBargeScheduleDetail', this.payloadMixed)
        this.showSuccessNotification(this, 'TBS successfully created/updated.')
        this.isLoading = false
        this.closeEditMode()
      } catch (e) {
        this.isLoading = false
        this.showFailedNotification(this, 'Failed to save changes, please try again')
      }
    }
  },
  props: {
    tbsId: {
      type: Number,
      default: () => null
    },
    tbsHeaderId: {
      type: Number,
      default: () => null
    },
    isEditModeProp: {
      type: Boolean,
      default: () => false
    },
    loadingPlanList: {
      type: Array,
      default: () => []
    },
    onCancelEdit: {
      type: Function,
      default: () => {}
    }
  }
}
</script>